module.exports = __webpack_public_path__ + "static/img/ZB_logo.53ddc4ee.png";